import api from '@/api'
import pageBuilderElements from '@/data/pageBuilderElements'
import formBuilderElements from '@/data/formBuilderElements'

// loading: false,
// drag: false,
// pageElementDrag: false,
// listElementDrag: false,
// propsModalOpen: false,
// currentElement: {},
// currentElementIndex: 0,

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop)
}

function arraysEqual(arr1, arr2) {
  if (!arr1) {
    arr1 =[]
  }
  if (!arr2) {
    arr2 =[]
  }
  if (arr1.length !== arr2.length) {
    return false
  }
  for (let i = arr1.length; i--; ) {
    if (arr1[i] !== arr2[i]) {
      return false
    }
  }

  return true
}

function initialState() {
  return {
    pageElements: [],
    originalPageElements: [],
    currentElement: {},
    currentElementIndex: 0,
    primary_user_id: 1,
    secondary_user_id: 2,
    buildType: 'content',
    propsModalOpen: false,
    editMode: false,
    parentRow: '',
    parentRowColumn: '',
  }
}

export default {
  namespaced: true,

  state: initialState,

  getters: {
    elementsHaveChanged(state) {
      return !arraysEqual(state.originalPageElements, state.pageElements)
    },

    configByType(state) {
      const { type } = state.currentElement
      let config
      if (state.buildType === 'form') {
        let toSearch = type;
        if (type == 'media-file-upload') {
          toSearch = 'media-file'
        }
        config = formBuilderElements.find((el) => el.type === toSearch)
      } else {
        config = pageBuilderElements.find((el) => el.type === type)
      }
      return config
    },

    forEdit(state) {
      const elementsToReturn = []

      const pageElements = JSON.parse(JSON.stringify(state.pageElements))

      if (pageElements) {
        pageElements.forEach((element) => {
          const newProps = {}

          if (element.properties && element.properties instanceof Array) {
            element.properties.forEach(
              (prop) => (newProps[prop.key] = prop.value)
            )
            element.properties = newProps
          }

          elementsToReturn.push(element)
        })
      }

      return elementsToReturn
    },

    /**
     * Tried to merge the below two actions, not working
     */
    elementListForm() {
      const elementsToReturn = []

      formBuilderElements.forEach((element) => {
        const newElement = {
          icon: element.icon,
          title: element.title,
          description: element.description,
          type: element.type == 'media-file' && element.isUpload == true ? 'media-file-upload' : element.type, // backwards compat hack
          sort_order: 1,
          iconFill: element.iconFill || true,
          properties: {},
          hideModalWindow: element.hideModalWindow || false
        }

        if (element.hasOwnProperty('content')) {
          newElement.content = element.content || null
        }

        if (element.properties && element.properties instanceof Array) {
          // console.log("IS ARRAY: ", element.properties);
          element.properties.forEach(
            (prop) => (newElement.properties[prop.name] = null)
          )
        }

        if (!element.disabled) {
          elementsToReturn.push(newElement)
        }
      })

      return elementsToReturn
    },

    elementList() {
      const elementsToReturn = []

      pageBuilderElements.forEach((element) => {
        let iconFill
        if (
          typeof element.iconFill !== 'undefined' &&
          element.iconFill === true
        ) {
          iconFill = true
        } else if (
          typeof element.iconFill !== 'undefined' &&
          element.iconFill === false
        ) {
          iconFill = false
        } else {
          iconFill = true
        }
        const newElement = {
          icon: element.icon,
          title: element.title,
          description: element.description,
          type: element.type,
          iconFill,
          sort_order: 1,
          properties: {},
          hideModalWindow: element.hideModalWindow || false
        }

        if (element.hasOwnProperty('content')) {
          newElement.content = element.content || null
        }

        if (element.properties && element.properties instanceof Array) {
          // console.log("IS ARRAY: ", element.properties);
          element.properties.forEach((prop) => {
            newElement.properties[prop.name] = null
          })
        }

        if (!element.disabled) {
          elementsToReturn.push(newElement)
        }
      })

      return elementsToReturn
    },

    forServer(state) {
      const pageElements = JSON.parse(JSON.stringify(state.pageElements))

      const elementsToReturn = []

      if (pageElements) {
        pageElements.forEach((element) => {
          if (!element.content) {
            element.content = ''
          }

          let newProps = {}

          if (element.properties instanceof Array) {
            element.properties.forEach((prop) => {
              newProps[prop.key] = prop.value
            })
          } else {
            /**
             * If we are editing a group type, we need to stringify the JSON
             * else the DB / API doesn't return it properly
             */
            if (element.properties && element.properties.leftColumn) {
              element.properties.leftColumn = JSON.stringify(
                element.properties.leftColumn
              )
              element.properties.rightColumn = JSON.stringify(
                element.properties.rightColumn
              )
            }
            newProps = element.properties
          }

          element.properties = newProps

          elementsToReturn.push(element)
        })
      }

      return elementsToReturn
    },

    forRender(state) {
      const pageElements = JSON.parse(JSON.stringify(state.pageElements))
      const elementsToReturn = []

      if (pageElements) {
        pageElements.forEach((element) => {
          const elementProps = null
          let type = element.type

          // hack for backwards compat to fix mikes mistake
          if (state.buildType !== 'content' && element.type == 'media-file') {
            // need to check if the media file component is an upload one
            const mediaFileField = formBuilderElements.filter(elem => elem.type == 'media-file');
            if (mediaFileField && mediaFileField.length > 0) {
              if (mediaFileField[0].isUpload) {
                type = 'media-file-upload'
              }
            }
          }

          // if (element.properties) {
          //   elementProps = element.properties;
          // } else if (element.data && element.data.props) {
          //   elementProps = element.data.props;
          // } else {
          //   elementProps = {};
          // }

          const newElement = {
            id: element.id,
            type: type,
            data: {
              attrs: {},
              domProps: {},
              props: {},
            },
          }

          if (element.properties instanceof Array) {
            // console.log('element.properties instanceof Array', element.properties);
            element.properties.forEach((prop) => {
              newElement.data.props[prop.key] = prop.value
            })
          } else {
            newElement.data.props = element.properties
          }

          if (element.content) {
            newElement.data.domProps.innerHTML = element.content
          }

          /**
           * If we are a group, we need to render things a bit differently
           */
          if (newElement.type === 'base-row') {
            /**
             * Loading from the API returns a JSON string
             * Creating a new one renders an object
             * Standardise into an object
             */
            const leftCol =
              typeof newElement.data.props.leftColumn === 'string'
                ? JSON.parse(newElement.data.props.leftColumn)
                : newElement.data.props.leftColumn

            const rightCol =
              typeof newElement.data.props.rightColumn === 'string'
                ? JSON.parse(newElement.data.props.rightColumn)
                : newElement.data.props.rightColumn

            /**
             * If we have no data (i.e. a new group) pre-fill everything to a default value
             */
            if (leftCol && !leftCol.data) {
              leftCol.data = { props: {}, domProps: {} }
              if (leftCol.properties instanceof Array) {
                leftCol.properties.forEach((prop) => {
                  leftCol.data.props[prop.name] = prop.value
                    ? prop.value
                    : 'Click to Edit'
                })
              } else {
                leftCol.data.props = leftCol.properties
              }

              if (leftCol.content) {
                leftCol.data.domProps.innerHTML = leftCol.content
              }
            }
            if (rightCol && !rightCol.data) {
              rightCol.data = { props: {}, domProps: {} }
              if (rightCol.properties instanceof Array) {
                rightCol.properties.forEach((prop) => {
                  rightCol.data.props[prop.name] = prop.value
                    ? prop.value
                    : 'Click to Edit'
                })
              } else {
                rightCol.data.props = rightCol.properties
              }

              if (rightCol.content) {
                rightCol.data.domProps.innerHTML = rightCol.content
              }
            }
          }

          elementsToReturn.push(newElement)
        })
      }

      return elementsToReturn
    },
  },

  mutations: {
    changeOrder(state, newOrder) {
      //
    },

    setPageElements(state, elements) {
      // update a page
      if (!elements || elements.length < 1) {
        state.pageElements = []
        return
      }
      const allElements = [...elements]
      allElements.forEach((elem) => {
        // For groups, if we are from the db, we need to remap properties from 0 and 1 to left and right
        if (elem.type === 'base-row' && elem.properties[0]) {
          let newProps = {}
          if (elem.properties.length === 2) {
            newProps = {
              leftColumn: JSON.parse(elem.properties[0].value),
              rightColumn: JSON.parse(elem.properties[1].value),
            }
          } else {
            const columns = ['leftColumn', 'rightColumn']
            elem.properties.forEach((prop) => {
              newProps[prop.key] = columns.includes(prop.key)
                ? JSON.parse(prop.value)
                : prop.value
            })
          }
          elem.properties = newProps
        }
      })
      state.pageElements = elements
    },

    setOriginalPageElements(state, elements) {
      state.originalPageElements = elements
    },

    setCurrentElement(state, element) {
      state.currentElement = Object.assign({}, element)
    },

    setCurrentElementIndex(state, index) {
      state.currentElementIndex = index
    },

    update(state, element) {
      // Need to check if we are updating on the root or within a group

      // update node as normal
      if (state.parentRow === '' || state.parentRowColumn == '') {
        // state.pageElements[state.currentElementIndex] = element;
        state.pageElements.splice(state.currentElementIndex, 1, element)
      } else {
        /**
         * We should have stored the node index and column by here
         * TODO: Fallback/error in case there is neither
         */

        const { parentRow, parentRowColumn, pageElements } = state

        const rowToUpdate = JSON.parse(JSON.stringify(pageElements[parentRow]))
        rowToUpdate.id = null

        // Here, we want to take the properties of the inner row elements, and set them within the properites of the parent element
        // TODO: Assuming a lot about the props and domProps stuff here, needs to be scalable if poss
        rowToUpdate.properties[parentRowColumn] = element
        rowToUpdate.properties[parentRowColumn].data.props = element.properties
        rowToUpdate.properties[parentRowColumn].data.domProps.innerHTML =
          element.content
        state.pageElements.splice(parentRow, 1, rowToUpdate)

        state.parentRow = ''
        state.parentRowColumn = ''
      }
    },
    setType(state, type) {
      state.buildType = type
    },

    setModalOpen(state, type) {
      state.propsModalOpen = type

      if (type === false) {
        // reset these here just in case
        state.parentRow = ''
        state.parentRowColumn = ''
      }
    },
    setEditMode(state, type) {
      state.editMode = type
    },

    /**
     * If we are editing a group, we basically need to store which parent node and column we are updating
     */
    setParentRow(state, { rowNum, column }) {
      state.parentRowColumn = column
      state.parentRow = rowNum
    },
  },

  actions: {
    // Fetches all the page elements
    list({ commit }, pageId) {
      return new Promise((resolve, reject) => {
        api()
          .get(`/content/page/${pageId}/elements`)
          .then((response) => {
            commit('setPageElements', response.data.data.element)
            commit('setOriginalPageElements', response.data.data.element)
            resolve(response.data.data.element)
          })
          .catch((error) => {
            if (
              error.response &&
              hasProp(error.response.data.data, 'element')
            ) {
              commit('setPageElements', error.response.data.data.element)
              resolve(error.response.data.data.element)
            } else {
              reject(error.response.data)
            }
          })
      })
    },

    /**
     * This is the same as above almost, but seperate out for now to avoid confusion
     */
    async listDraft({ commit }, attrs) {
      const { pageId } = attrs
      const setState = attrs.setState ? attrs.setState : true
      let resp

      try {
        resp = await api().get(`content/page/${pageId}/draft/elements`)
        if (setState) {
          commit('setPageElements', resp.data.data.element)
          commit('setOriginalPageElements', resp.data.data.element)
        }
        return Promise.resolve(resp.data.data.element)
      } catch (err) {
        commit('setPageElements', null)
        commit('setOriginalPageElements', null)
        return Promise.reject(Error(err))
      }
    },

    create({ commit }, { pageId, element }) {
      return new Promise((resolve, reject) => {
        api()
          .put(`/content/page/${pageId}/element`, { element })
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            if (
              error.response &&
              hasProp(error.response.data.data, 'element')
            ) {
              resolve(error.response.data.data)
            } else {
              reject(error.response.data)
            }
          })
      })
    },

    createProperty({ commit }, { pageId, elementId, property }) {
      return new Promise((resolve, reject) => {
        api()
          .put(`/content/page/${pageId}/element/${elementId}`, { property })
          .then((response) => {
            resolve(response.data.data.property[0])
          })
          .catch((error) => {
            if (
              error.response &&
              hasProp(error.response.data.data, 'property')
            ) {
              resolve(error.response.data.data.property[0])
            } else {
              reject(error.response.data)
            }
          })
      })
    },

    update({ commit }, { pageId, element }) {
      return new Promise((resolve, reject) => {
        api()
          .put(`/content/page/${pageId}/element/${element.id}`, { element })
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            if (
              error.response &&
              hasProp(error.response.data.data, 'element')
            ) {
              resolve(error.response.data.data)
            } else {
              reject(error.response.data)
            }
          })
      })
    },

    // Adds the element to the page builder stack
    add({ state, commit }, element) {
      const { pageElements, currentElement } = state

      if (element) {
        pageElements.push(element)
      } else {
        pageElements.push(currentElement)
      }

      commit('setPageElements', pageElements)
      commit('setCurrentElement', {})
    },

    // Removes the element from the page builder stack
    remove({ state }, elementIndex) {
      state.pageElements.splice(elementIndex, 1)
    },

    // Duplicates an element in the page builder stack
    duplicate({ state }, elementIndex) {
      const clone = { ...state.pageElements[elementIndex] }
      // state.pageElements.push(clone);
      state.pageElements.splice(elementIndex, 0, clone)
    },
  },
}
